import authAxios from "../auth/authAxios";

export const pokerApi = {
  createGame: (isAiGame = false, options = {}) =>
    authAxios.post("poker/", { is_ai_game: isAiGame, ...options }).then((r) => r.data),

  getGame: (gameId) =>
    authAxios.get(`poker/${gameId}/`).then((r) => r.data),

  updateSettings: (gameId, settings) =>
    authAxios.patch(`poker/${gameId}/settings/`, settings).then((r) => r.data),

  joinGame: (gameId) =>
    authAxios.post(`poker/${gameId}/join/`).then((r) => r.data),

  action: (gameId, action, amount = null) =>
    authAxios.post(`poker/${gameId}/action/`, { action, amount }).then((r) => r.data),

  nextHand: (gameId) =>
    authAxios.post(`poker/${gameId}/next-hand/`).then((r) => r.data),

  listTournaments: () =>
    authAxios.get("poker/tournaments/").then((r) => r.data),

  createTournament: (payload) =>
    authAxios.post("poker/tournaments/", payload).then((r) => r.data),

  getTournament: (tournamentId) =>
    authAxios.get(`poker/tournaments/${tournamentId}/`).then((r) => r.data),

  registerTournament: (tournamentId) =>
    authAxios.post(`poker/tournaments/${tournamentId}/register/`).then((r) => r.data),

  withdrawTournament: (tournamentId) =>
    authAxios.post(`poker/tournaments/${tournamentId}/withdraw/`).then((r) => r.data),

  removeTournamentRegistration: (tournamentId, registrationId) =>
    authAxios.post(`poker/tournaments/${tournamentId}/registrations/${registrationId}/remove/`).then((r) => r.data),

  startTournament: (tournamentId) =>
    authAxios.post(`poker/tournaments/${tournamentId}/start/`).then((r) => r.data),

  // Creator-only, pre-start only -- backend rejects (400) once started, or
  // (403) if the caller isn't the creator. Hard delete, no undo.
  deleteTournament: (tournamentId) =>
    authAxios.delete(`poker/tournaments/${tournamentId}/`).then((r) => r.data),

  // Creator-only, and only until locked (started, or within 15 minutes of
  // scheduled_start) -- backend rejects (400) once locked, (403) if the caller
  // isn't the creator. Partial update: only send the fields being changed.
  editTournament: (tournamentId, payload) =>
    authAxios.patch(`poker/tournaments/${tournamentId}/`, payload).then((r) => r.data),

  // MTT (multi-table tournament) -- backend surface is poker/mtt/..., distinct
  // from the legacy poker/tournaments/... (single-table ScheduledPokerMatch)
  // system above. GET poker/mtt/ returns a bare array (no `.results` wrapper),
  // already filtered server-side to registering/running tournaments only.
  loadMttTournamentsForDashboard: () =>
    authAxios.get("poker/mtt/").then((r) => r.data),

  registerMtt: (tournamentId) =>
    authAxios.post(`poker/mtt/${tournamentId}/register/`).then((r) => r.data),

  // 404s if the requesting user never registered for this tournament -- callers
  // catch that themselves to mean "unregistered" rather than treating it as a
  // load failure (see MttTournamentCard).
  getMttEntry: (tournamentId) =>
    authAxios.get(`poker/mtt/${tournamentId}/my-entry/`).then((r) => r.data),

  // Same collection endpoint as loadMttTournamentsForDashboard's GET --
  // POST creates a Tournament (poker/mtt_views.py's mtt_list_create).
  createMttTournament: (payload) =>
    authAxios.post("poker/mtt/", payload).then((r) => r.data),

  // Creator-only, pre-start (status="registering") only -- backend rejects
  // (400) once started, or (403) if the caller isn't the creator. Hard
  // delete, no undo.
  deleteMttTournament: (tournamentId) =>
    authAxios.delete(`poker/mtt/${tournamentId}/`).then((r) => r.data),

  // Unrestricted read (any authenticated user), full fields -- unlike
  // loadMttTournamentsForDashboard's list shape, this includes blind_schedule/
  // break_schedule/starting_stack/max_tables, needed to pre-fill the edit form.
  getMttTournament: (tournamentId) =>
    authAxios.get(`poker/mtt/${tournamentId}/`).then((r) => r.data),

  // Creator-only, pre-start (status="registering") only -- backend rejects
  // (400) once started, or (403) if the caller isn't the creator. Partial
  // update: only send the fields being changed.
  editMttTournament: (tournamentId, payload) =>
    authAxios.patch(`poker/mtt/${tournamentId}/`, payload).then((r) => r.data),
};
